import React, { createContext, useState, useContext, ReactNode } from 'react';

export interface IAssistance {
  id: number;
  open: Date;
  os_number: number;
  os_control: string;
  customer_id: number;
  customer: string;
  is_adaptation?: number;
  is_repair?: number;
  is_assistance?: number;
  assistance_type: string;
  request: string;
  technical_analysis?: string;
  procedures?: string;
  accept?: Date;
  cancel?: Date;
  register_by_id: number;
  register_by_name: string;
}

interface PDFContextData {
  // eslint-disable-next-line no-unused-vars
  setPdfAssistanceData: (data: IAssistance) => void;
  pdfAssistanceData: IAssistance;
}

const PDFContext = createContext<PDFContextData>({} as PDFContextData);

const PDFAssistanceProvider = ({ children }: { children: ReactNode }) => {
  const [pdfAssistanceData, setPdfAssistanceData] = useState<IAssistance>(
    {} as IAssistance,
  );

  return (
    <PDFContext.Provider value={{ pdfAssistanceData, setPdfAssistanceData }}>
      {children}
    </PDFContext.Provider>
  );
};

function usePDFAssistanceData(): PDFContextData {
  const context = useContext(PDFContext);

  return context;
}

export { PDFAssistanceProvider, usePDFAssistanceData };
